import { skipToken } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { ActivityParent } from "./types";

type TrpcOptionsProxy = ReturnType<typeof trpc.useTRPC>;

export const parentVisitsQueryOptions = (
    trpcClient: TrpcOptionsProxy,
    parent: ActivityParent,
) => {
    switch (parent.kind) {
        case "organization":
            return trpcClient.calendarEvents.listByBusiness.queryOptions({
                businessId: parent.id,
            });
        case "contact":
            return trpcClient.calendarEvents.listByParent.queryOptions({
                parentId: parent.id,
            });
        case "client":
        case "homeCareLead":
            return trpcClient.calendarEvents.listByParent.queryOptions(skipToken);
    }
    const exhaustiveCheck: never = parent;
    throw new Error(`Unhandled activity parent ${String(exhaustiveCheck)}`);
};
